<template>
  <div class="wrapper">
    <LogoMark class="loading-panel__logo" />

    <p>Loading&hellip;</p>
  </div>
</template>

<script>
import LogoMark from "@/assets/svg/logo-mark-loading.svg";

export default {
  name: "LoadingAnimation",
  components: {
    LogoMark,
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: $white;
  transition: all 0.3s ease;
}

.loading-panel__logo {
  width: 120px;
  stroke: white;
  stroke-width: 20;

  .background {
    stroke-opacity: 0.1;
  }

  .animation {
    stroke-dasharray: 500;
    stroke-dashoffset: 500;
    animation: STROKE_DASH 2s linear infinite;
  }
}

@keyframes STROKE_DASH {
  0% {
    stroke-dashoffset: 500;
  }
  50% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: -500;
  }
}
</style>
